<section class="main_section">
  <!-- Header -->
  <div class="section_top_header">
    <div class="section_top_header_text" *ngIf="!data?.edit">
      New Template
    </div>
    <div class="section_top_header_text" *ngIf="data?.edit">
      Update Template Details
    </div>
    <button class="close_btn" (click)="close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="section_body">

     <!-- Business Sub-Industry -->
    <div class="form-group read-only" *ngIf="data?.edit">
      <label class="form-label">Business Sub-Industry</label>
      <mat-form-field class="sfull-width domain-input" appearance="outline" disabled>
        <input matInput [value]="data.data.subIndustry.name" disabled />
      </mat-form-field>
    </div>

    <div class="form-group" *ngIf="!data?.edit">
      <label class="form-label">Business Sub-Industry <span class="required-asterisk">*</span></label>

      <mat-form-field class="sfull-width domain-input" appearance="outline">
        <mat-icon matPrefix class="search-icon">search</mat-icon>
        <input type="text"
          placeholder="Search business type (e.g. Gym, Bakery...)"
          matInput
          [formControl]="myControl"
          [matAutocomplete]="auto1"
          (ngModelChange)="getVal($event)" />
        <mat-autocomplete #auto1="matAutocomplete" class="modern-autocomplete">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name"
            (click)="selectBusinessType(option)"
            (keyup.enter)="selectBusinessType(option)">
            <div class="option-container">
              <span class="option-name">{{ option.name }}</span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <!-- Static Search -->
      <!-- <mat-form-field class="sfull-width domain-input" appearance="outline" *ngIf="websiteType === 'STATIC'">
        <mat-icon matPrefix class="search-icon">search</mat-icon>
        <input type="text"
          placeholder="Search business type (e.g. Gym, Bakery...)"
          matInput
          [formControl]="myControl"
          [matAutocomplete]="auto1"
          (ngModelChange)="getVal($event)" />
        <mat-autocomplete #auto1="matAutocomplete" class="modern-autocomplete">
          <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name"
            (click)="selectBusinessType(option)"
            (keyup.enter)="selectBusinessType(option)">
            <div class="option-container">
              <span class="option-name">{{ option.name }}</span>
            </div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field> -->

      <!-- E-commerce Search -->
      <!-- <mat-form-field class="sfull-width domain-input" appearance="outline" *ngIf="websiteType === 'E_COMMERCE'">
        <mat-icon matPrefix class="search-icon">search</mat-icon>
        <input type="text"
          placeholder="Search business type (e.g. Fashion, Electronics...)"
          matInput
          [formControl]="ecomMyControl"
          [matAutocomplete]="autoEcom"
          (ngModelChange)="getVal($event)" />
        <mat-autocomplete #autoEcom="matAutocomplete" class="modern-autocomplete">
          <mat-option *ngFor="let option of ecomFilteredOptions | async" [value]="option.name"
            (click)="selectBusinessType(option)"
            (keyup.enter)="selectBusinessType(option)">
            <div class="option-container">
              <span class="option-name">{{ option.name }}</span>
            </div>
          </mat-option>
          <mat-option class="info-option" disabled>
            <mat-icon>info</mat-icon>
            <span>E-Commerce Templates</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field> -->
    </div>

    <!-- Template Name -->
    <div class="form-group">
      <label class="form-label">Template Name <span class="required-asterisk">*</span></label>
      <mat-form-field class="sfull-width domain-input" appearance="outline">
        <input
          matInput
          placeholder="e.g. Premium Dental Clinic"
          [(ngModel)]="templateName"
          maxlength="100"
          (input)="checkTemplateNameLength()"
          required
        />
      </mat-form-field>
      <div class="form-hint-container">
        <div *ngIf="templateName && templateName.length > 100" class="text-danger">
          Template Name cannot exceed 100 characters.
        </div>
        <div class="character-counter" [class.warning]="templateName.length >= 90">
          {{ templateName?.length || 0 }}/100
        </div>
      </div>
    </div>

    <!-- Description -->
    <div class="form-group">
      <label class="form-label">Description <span class="required-asterisk">*</span></label>
      <div class="textarea-wrapper">
        <textarea
          class="custom-textarea modern-textarea"
          placeholder="Describe the business or template purpose (e.g. A sleek, modern agency site...)"
          [(ngModel)]="desc"
          rows="3"
          maxlength="500"
          (input)="checkDescriptionLength()"
          required>
        </textarea>
      </div>
      <div class="form-hint-container">
        <div *ngIf="desc && desc.length > 500" class="text-danger">
          Description cannot exceed 500 characters.
        </div>
        <div class="character-counter" [class.warning]="desc.length >= 450">
          {{ desc?.length || 0 }}/500
        </div>
      </div>
    </div>

    <!-- Website Type Segmented Control -->
     <label class="form-label">Website Type</label>
    <div class="tabs-container">
      <button
        type="button"
        class="tab-btn"
        [class.active]="websiteType === 'E_COMMERCE'"
        (click)="websiteType = 'E_COMMERCE'">
        <mat-icon class="tab-icon">shopping_bag</mat-icon>
        <span class="tab-label">Online Store</span>
      </button>
      <button
        type="button"
        class="tab-btn"
        [class.active]="websiteType === 'STATIC'"
        (click)="websiteType = 'STATIC'">
        <mat-icon class="tab-icon">language</mat-icon>
        <span class="tab-label">Informational</span>
      </button>
    </div>
   

    <!-- Action Buttons -->
    <div class="action-buttons-group">
      <!-- Manual Generate -->
      <button (click)="submit()" *ngIf="!data?.edit" class="btn-manual-generate">
        <span *ngIf="submitLoader" class="loader-span">
          <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading
        </span>
        <span *ngIf="!submitLoader" class="btn-content">
          <mat-icon>arrow_forward</mat-icon>
          <span>Manually Generate</span>
        </span>
      </button>

      <!-- AI Generate -->
      <button (click)="templateAutoGenerate()"
        *ngIf="!data?.edit && !templateGeneration"
        class="btn-ai-generate"
        [disabled]="!bType || !templateName || !desc">
        <mat-icon>auto_awesome</mat-icon>
        <span>Generate with AI</span>
      </button>

      <button (click)="templateAutoGenerate()"
        *ngIf="!data?.edit && templateGeneration"
        class="btn-ai-generate active-loading"
        disabled>
        <i class="fas fa-spinner fa-spin"></i>&nbsp;Generating...
      </button>

      <!-- Edit Template -->
      <button (click)="editTemplate()" *ngIf="data?.edit" class="btn-edit-template">
        <span *ngIf="submitLoader" class="loader-span">
          <i class="fas fa-spinner fa-spin"></i>&nbsp;Loading
        </span>
        <span *ngIf="!submitLoader" class="btn-content">
          <mat-icon>save</mat-icon>
          <span>Save Changes</span>
        </span>
      </button>
    </div>
  </div>
</section>
